export default "__VITE_ASSET__3$BBRXNn__"